//@flow
import BaseFilter from './base_filter'
import type DataTables from 'datatables.net';

export default class TagSearch extends BaseFilter {
    filters: {[string|null|void]: {[string]: Set<string>}};
    searchText: ?string;
    category: ?string;
    context: (searchText: ?string) => void;

    constructor(callback: () => void) {
        super(callback);
        this.filters = {}
        this.searchText = this.category = null;
        this.context = this.call.bind(this);
    }

    call(searchText: ?string, category: ?string): void {
        this.searchText = searchText;
        this.category = category;
        this.invoke()
    }

    addFilter(): void {
        let cat = this.category || ''
        if (!this.filters[this.column] || !this.filters[this.column][cat]) {
            return this.setFilter();
        }

        this.filters[this.column][cat].add(this.searchText ||'');
    }

    setFilter(): void {
        let col = this.filters[this.column] = this.filters[this.column] || {};
        col[this.category || ''] = new Set([this.searchText || '']);
    }

    clearFilter(): void {
        if (this.searchText) {
            let set = this.filters[this.column][this.category || ''];
            set.delete(this.searchText);
            if (set.size === 0) {
                delete this.filters[this.column][this.category || '']
            }
            return;
        }
        if (this.column) {
            this.filters[this.column] = {};
        } else {
            this.filters = {}
        }
    }

    apply(dataTable: DataTables.Api): void {
        Object.keys(this.filters).forEach(filter => {
            if (!this.filters[filter] ||
                 Object.keys(this.filters[filter]).length === 0) return;
            let filterTags = new Set();
            Object.values(this.filters[filter]).forEach((tags: any) =>
                          tags.forEach(t => filterTags.add(t)));
            let filterText = `((^|,|;)(${Array.from(filterTags).join('|')})($|,|;))`;

            if (filter !== 'undefined') {
                dataTable.column(`${filter}:name`).search(filterText, true, false);
            } else {
                dataTable.search(filterText, true, false);
            }
        }, this);
    }

    getDescription(): any {
        let tagFilters = {}
        Object.values(this.filters).forEach((tags: any) => {
            Object.keys(tags).forEach((category: string) => {
                let cat = tagFilters[category] = tagFilters[category] || new Set();
                tags[category].forEach(tag => cat.add(tag));
            })
        })
        let categories = Object.keys(tagFilters);
        if (categories.length === 0) return {};
        categories.forEach(category => {
            tagFilters[category] = Array.from(tagFilters[category]).join(';');
        })
        return {tag_filters: tagFilters}
    }
}